export const UpdateBlogList = () => {
  return `
        query Blogs($pagination: PaginationArg, $sort: [String], $status: PublicationStatus, $filters: BlogFiltersInput, $blogsConnectionPagination2: PaginationArg, $locale: I18NLocaleCode) {
  blogs(pagination: $pagination, sort: $sort, status: $status, filters: $filters, locale: $locale) {
    author {
      documentId
      avatar {
        caption
        name
        url
        publishedAt
        size
        updatedAt
        width
        documentId
      }
      name
    }
    slug
    short_description
    publishedAt
    locale
    title
    updatedAt
    priority
    media {
      name
      size
      url
      updatedAt
      width
      caption
    }
    documentId
    category {
      name
      slug
    }
  }
  blogs_connection(pagination: $blogsConnectionPagination2) {
    pageInfo {
      total
      page
      pageSize
      pageCount
    }
  }
}`;
};
